import { observable } from "mobx";
import AgendamentoContainerService from "../../../../../services/AgendamentoContainerService";
import _ from 'lodash';

export default class CardNotaFiscalStore {

    @observable expandido;

    @observable paises;
    @observable UFs;
    @observable transportadorasNotaFiscal;
    @observable paisSelecionado;

    @observable atualizarCnpjEmissor;
    @observable atualizarCnpjDest;

    @observable flagAtivo;
    @observable atualizaBagagem;

    nfModificando;

    constructor() {
        this.expandido = true;

        this.paises = [];
        this.transportadorasNotaFiscal = [];
        this.UFs = [];
        this.atualizarCnpjEmissor = true;
        this.atualizarCnpjDest = true;

        this.flagAtivo = false;
        this.atualizaBagagem = true;

        this.paisSelecionado = false;
        
        this.service = new AgendamentoContainerService();
    }

    carregarPaises = () => {
        this.paises = [];
        this.service.listarPaises().then(response => {
            this.paises = response.data;
        }).catch(error => {
            console.log(error);
        })
    };

    setPais = (valor, dados, setDados) =>{
        setDados(`${dados}.Nf.CdUnidadeFedDest`, "");
        setDados(`${dados}.Nf.NomCidadeDest`, "");
        if (valor && (valor.value==="BR" || valor ==="BR"))
        {
            this.paisSelecionado = valor;
            this.carregarUFs(_.get(this.paisSelecionado,`value`) ? this.paisSelecionado.value : this.paisSelecionado);
        }
        else {
            this.paisSelecionado = false;
            setDados(`${dados}.Nf.CdUnidadeFedDest`, "EX");
            setDados(`${dados}.Nf.NomCidadeDest`, "EXTERIOR");
        }
    };
    
    carregarUFs = (pais) => {
        this.UFs = [];
        this.service.listarUFs(pais).then(response => {
            if (response.data && response.data.length>0) {
                this.UFs = response.data;
            } else {
                this.UFs = [];
            }
        }).catch(error => {
            console.log(error);
        });
    };

    clickExpandir = () => {
        this.expandido = !this.expandido;
    };

    setCNPJEmissor = (cnpj, nf, setdados) => {
        if(cnpj){
            this.nfModificando = nf;
            setdados(`${this.nfModificando}.Nf.Cnpjs`, cnpj);
            
            setdados(`${this.nfModificando}.Nf.RazaoSocialEmissor`, "");
            setdados(`${this.nfModificando}.Nf.ClibrsId`, 0);
            setdados(`${this.nfModificando}.Nf.ClibrsIdCobrade`, 0);
            if (cnpj && cnpj.length>0) {
                this.service.buscarClientePorCnpj(cnpj).then(response => {
                    this.atualizarCnpjEmissor = false;
                    if (response.data) {
                        setdados(`${this.nfModificando}.Nf.RazaoSocialEmissor`, response.data.RazaoSocialEmpParcComerc);
                        setdados(`${this.nfModificando}.Nf.ParcIdEmiss`, response.data.ParcId);
                        setdados(`${this.nfModificando}.Nf.EstabIdEmiss`, response.data.EstabId);
                        setdados(`${this.nfModificando}.Nf.CnpjEmissor_lblNaoExiste`, "");
                    } else {
                        setdados(`${this.nfModificando}.Nf.CnpjEmissor_lblNaoExiste`, "Cliente não cadastrado");
                    }

                    setTimeout(function() {
                        this.atualizarCnpjEmissor = true;
                    }.bind(this), 1)

                }).catch( erro => {
                    console.log(erro)
                });
            }else{
                this.atualizarCnpjEmissor = false;
                setdados(`${this.nfModificando}.Nf.CnpjEmissor_lblNaoExiste`, "");
                setTimeout(function() {
                    this.atualizarCnpjEmissor = true;
                }.bind(this), 1)
            }
        }
    };

    setCNPJDestinatario = (cnpj, nf, setdados) => {
        if(cnpj){
            this.nfModificando = nf;
            
            setdados(`${this.nfModificando}.Nf.CnpjDest`, cnpj);
            
            setdados(`${this.nfModificando}.Nf.RazaoSocialDest`, "");
            if (cnpj && cnpj.length>0) {
                this.service.buscarClientePorCnpj(cnpj).then(response => {
                    this.atualizarCnpjDest = false;
                    if (response.data) {
                        setdados(`${this.nfModificando}.Nf.RazaoSocialDest`, response.data.RazaoSocialEmpParcComerc);
                        setdados(`${this.nfModificando}.Nf.CnpjDestinatario_lblNaoExiste`, "");
                    } else {
                        setdados(`${this.nfModificando}.Nf.CnpjDestinatario_lblNaoExiste`, "Cliente não cadastrado");
                    }

                    setTimeout(function() {
                        this.atualizarCnpjDest = true;
                    }.bind(this), 1)

                }).catch( erro => {
                    console.log(erro)
                });
            }
            else 
            {
                this.atualizarCnpjDest = false;
                setdados(`${this.nfModificando}.Nf.CnpjDestinatario_lblNaoExiste`, "");
                setTimeout(function() {
                    this.atualizarCnpjDest = true;
                }.bind(this), 1)
            }
        }
    };

    setCNPJDestinatarioSemPensar = (cnpj, nf, setdados) => {
        if (cnpj) {
            setdados(`${nf}.Nf.CnpjDest`, cnpj);
        }
    };

    carregarTransportadorasNotaFiscal =  () => {
            this.transportadorasNotaFiscal = [];
             this.service.listarTransportadoras().then(response => {
                this.transportadorasNotaFiscal = response.data;
                

            }).catch(err =>  console.log(err))
    };

    verificaCampoVazioNF = (value) => {
        if(value === "" || value === null || value === undefined){
            return true
        }else{
            return false
        }
    }

}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/entrada-containers/stores/CardNotaFiscalStore.js